/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Management
 * Device Manager API CRUD https://bitbucket.org/nwaveio/device-management-openapi/src/master/
 *
 * The version of the OpenAPI document: 2.1.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    ResponseReason,
    Zone,
} from './';

/**
 * @export
 * @interface ResponseZonesWithTotal
 */
export interface ResponseZonesWithTotal {
    /**
     * @type {Array<Zone>}
     * @memberof ResponseZonesWithTotal
     */
    data: Array<Zone>;
    /**
     * @type {number}
     * @memberof ResponseZonesWithTotal
     */
    total: number;
    /**
     * @type {ResponseReason}
     * @memberof ResponseZonesWithTotal
     */
    reason: ResponseReason;
    /**
     * @type {string}
     * @memberof ResponseZonesWithTotal
     */
    message: string;
}
